export const SHOW_CONTACT_LOADER = "SHOW_CONTACT_LOADER"
export const HIDE_CONTACT_LOADER = "HIDE_CONTACT_LOADER"

export const CONTACT_SENT = 'CONTACT_SENT'
export const CONTACT_SEND_FAILED = 'CONTACT_SEND_FAILED'


// WEBPACK FOOTER //
// ./src/store/contacts/actionTypes.js